import React, { useState, useCallback } from 'react';
import * as S from './style';

import { ReactComponent as CheckOn } from 'assets/img/common/ic_check_arrow_blue.svg';

export interface Props {
    inputName: string;
    contents: string;
    value?: string | number;
    width?: number;
    onChangeHandle?: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

function CheckBox({ inputName, contents, width, onChangeHandle, ...props }: Props): React.ReactElement {
    const [isChecked, setisChecked] = useState<boolean>(false);

    const onChange = useCallback(
        (e: React.ChangeEvent<HTMLInputElement>) => {
            const { checked } = e.target;
            setisChecked(checked);

            if (onChangeHandle) {
                onChangeHandle(e);
            }
        },
        [onChangeHandle]
    );

    return (
        <S.CheckBoxWrapper checked={isChecked} width={width}>
            <S.CheckBox type={'checkbox'} name={inputName} {...props} onChange={onChange} />
            <S.IconWrapper>{isChecked && <CheckOn />}</S.IconWrapper>
            <S.CheckBoxLabel>{contents}</S.CheckBoxLabel>
        </S.CheckBoxWrapper>
    );
}

export default CheckBox;
